import { GlobalButton, AutocompleteInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';
import { LogisticOperatorsFilter } from '../models';
import useLogisticOperatorsSearchBar from '../hooks/useLogisticOperatorsSearchBar';

interface SearchBarProps {
  initialFilter: LogisticOperatorsFilter;
  filter: LogisticOperatorsFilter;
  search: (filter: LogisticOperatorsFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const {
    selectedNameOption,
    selectedBusinessOption,
    nameInput,
    setNameInput,
    businessInput,
    setBusinessInput,
    nameSuggestionOptions,
    businessSuggestionOptions,
    isNameLoading,
    isBusinessLoading,
    handleNameOperatorSelect,
    handleBusinessOperatorSelect,
    resetFilters,
    handleSearch,
    isNameFieldDisabled,
    isBusinessFieldDisabled,
  } = useLogisticOperatorsSearchBar({ initialFilter, filter, search });

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-sm shadow-xl gap-5'>
      <div className='grid grid-cols-4 gap-4'>
        <div className='bg-gray-50 p-4 rounded-lg col-span-4 sm:col-span-2'>
          <h3 className='text-lg font-semibold text-gray-700 mb-4'>
            Filtros de Búsqueda
          </h3>
          <div className='flex flex-col gap-4'>
            <AutocompleteInput
              name='logistic-operator-list-name'
              placeholder='Nombre del operador'
              value={selectedNameOption}
              inputValue={
                selectedNameOption ? selectedNameOption.label : nameInput
              }
              onChange={handleNameOperatorSelect}
              onInputChange={setNameInput}
              options={nameSuggestionOptions}
              required={false}
              loading={isNameLoading}
              disabled={isNameFieldDisabled}
            />
          </div>
        </div>

        <div className='bg-gray-50 p-4 rounded-lg col-span-4 sm:col-span-2'>
          <h3 className='text-lg font-semibold text-gray-700 mb-4'>
            Razón social
          </h3>
          <div className='flex flex-col gap-4'>
            <AutocompleteInput
              name='logistic-operator-list-business-name'
              placeholder='Razón social'
              value={selectedBusinessOption}
              inputValue={
                selectedBusinessOption
                  ? selectedBusinessOption.label
                  : businessInput
              }
              onChange={handleBusinessOperatorSelect}
              onInputChange={setBusinessInput}
              options={businessSuggestionOptions}
              required={false}
              loading={isBusinessLoading}
              disabled={isBusinessFieldDisabled}
            />
          </div>
        </div>
      </div>

      <div className='flex justify-start' />

      <div className='flex gap-3 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilters}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
